import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {Field} from '@app/interfaces';
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
    selector: 'app-form-input-textblock',
    templateUrl: './form-input-textblock.component.html',
    styleUrls: ['./form-input-textblock.component.scss'],
    standalone: false
})
export class FormInputTextblockComponent implements OnInit, OnDestroy {
    @Input() control: AbstractControl;

    @Input() field: Field<string>;

    private destroy$ = new Subject<void>();

    constructor(private cdr: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.control.statusChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.cdr.detectChanges();
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
    }
}
